import {Box, Shimmer, Stack, View} from "@unibuddy/patron";
import React from "react";

export function BlogPostPlaceholder() {
    return (
        <View
            minW="320px"
            width="100%"
            maxW="640px"
            borderColor="grey150"
            borderWidth={1}
            borderRadius="xsmall"
            marginBottom="small-medium"
            gap="small-medium"
        >
            <Box height="250px" paddingBottom="small-medium" width="100%">
                <Shimmer
                    viewBox="0 0 640 250"
                    preserveAspectRatio="none"
                    style={{display: "block", width: "100%", height: "250px"}}
                >
                    <rect x="0" y="0" rx="8" ry="8" width="640" height="250" />
                </Shimmer>
            </Box>
            <View padding="small-medium" gap="small">
                <Box height="30px" width="250px" bgColor="grey150" />
                <Stack space="xxsmall">
                    <Box height="20px" width="100%" bgColor="grey150" />
                    <Box height="20px" width="50%" bgColor="grey150" />
                </Stack>
            </View>
        </View>
    );
}
